import innerEmitter from "../../inner-emitter/inner-emitter";
import { INNER_EVENT } from "../../inner-emitter/inner-type";

class SSOManager {
  enable = false;

  ssoFailCount = 0;

  constructor() {
    innerEmitter.on(INNER_EVENT.JOIN_SCHEDULE_SUCCESS, ({ schedule }) => {
      if (schedule?.config?.sso) {
        innerEmitter.emit(INNER_EVENT.SSO_SWITCH, { enable: true });
      }
    });
    innerEmitter.on(INNER_EVENT.SSO_SWITCH, ({ enable }) => {
      this.enable = enable;
    });
  }

  handleUploadFailed() {
    this.ssoFailCount++;
    if (this.ssoFailCount > 3) {
      innerEmitter.emit(INNER_EVENT.SSO_SWITCH, { enable: false });
    }
  }
}

export default new SSOManager();
